export const environment = {
  enableFeature: false,
  production: false,


  environment: 'int',

  baseURL: "https://api.int.business.stories.me",



  redirectURL: "https://int.business.stories.me/login",



  apiEndPoint: "https://amgmaa-nonprod.mercedes-benz.com/aca",
  phraseEndPoint: 'https://api.phrase.com/v2/projects',


  proxyUrl: "https://proxy.int.stories.me",

  routeBaseURL: "https://int.stories.me",
  bpBaseURL: "https://int.business.stories.me",
  socketURL: 'wss://api.int.business.stories.me/',



  supported_language: ['en', 'de', 'en-GB', 'de-DE', 'es-ES', 'fr-FR', 'ko-KR', 'cs-CZ'],

};
